import axios from "axios";
import React from "react";

export const BASE_URL = "https://www.softforging.com/api/";
export const API_MOTO = `${BASE_URL}moto`;
export const API_SERVICES = `${BASE_URL}services`;
export const API_TECHNOLOGIES = `${BASE_URL}technologies`;
export const API_Contacts = `${BASE_URL}contacts-info`;

export function HandleApi(api, callback, errorCallback) {
 React.useEffect(() => {
  axios
   .get(api)
   .then((res) => {
    if (res) {
     callback(res.data);
    }
   })
   .catch((err) => {
    errorCallback({
     results: [{}],
    });
    console.error("Error fetching data:", err);
   });
 }, []);
}
